
    <div class="qbodyText" >{{myCount+1}}.

        <a [routerLink]="['/admin/envelop/quiz',quizEnvelop.server_quiz_envelop_id,question.server_question_id]">
          <span [appMath]="question.questionText"></span>
          <div *ngIf="question.isMediaPresent">
          <app-image-question *ngFor="let myImage of question.imageListQuestionBody" [questionId]="myImage.id" [partName]="myImage.part_name"></app-image-question>
          </div>

        </a>
    </div>
    <app-prompt-view-info *ngIf="question.prompts.length>0" [prompts]="question.prompts"></app-prompt-view-info>


